export default __webpack_public_path__ + "f058c9a2162e93c20576fd21e31bf35b.svg";